<template>
    <Tooltip
        ref="tooltipCopylink"
        :text="'Copylink Tooltip Text'"
        :timeout="6000"
    />
</template>
<script>
import Tooltip from '../Tooltip/Tooltip.vue'

export default {
    scopeName: 'copyLinkTooltip',
    components: {
        Tooltip
    },
    data() {
        return {
            initiator: null // Add to Wishlist button HTML element
        }
    },
    mounted() {
        this.init(this.$parent.$options.inititator)
    },
    methods: {
        init(el) {
            this.initiator = el
            this.initiator.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopImmediatePropagation()
            })
        },
        OnCopylinkButtonClick(button) {
            this.copyLink()
            this.triggerTooltip(button)
        },
        copyLink() {
            navigator.clipboard.writeText(window.location.href)
        },
        triggerTooltip(button) {
            if (
                this.$refs.tooltipCopylink &&
                typeof this.$refs.tooltipCopylink.Open === 'function'
            ) {
                this.$refs.tooltipCopylink.init(button)
                this.$refs.tooltipCopylink.Open()
            }
        }
    },
    render: () => null
}
</script>
